/* eslint-disable */

import React from 'react';
import moment from 'moment';
import ChatMessageAction from './ChatMessageAction';
import { Box, Grid, Stack, Typography } from '@mui/material';
import AttachmentFileDownload from './AttachmentFileDownload';
import ImageViewer from './ImageViewer';
import Reply from './Reply';
import { UserAvatar3 } from 'sections/chat/UserAvatar';

const MessageL = ({ message, date, name, image, file, msgObj, user, isSameUser, userId, privateConversation = false }) => {
  return (
    <Grid item xs={12}>
      <Stack direction="row" alignItems="flex-start">
        <Grid
          container
          justifyContent="flex-start"
          sx={{
            ...(isSameUser ? { mt: "3px" } : { mt: "5px" }),
          }}
        >
          <Grid item xs={10} md={9} xl={8}>
            {!isSameUser && (
              <Stack direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={1.25}>
                <UserAvatar3 userId={userId} width={30} height={30} />
                <Typography variant="subtitle1" color="textPrimary" sx={{ overflowWrap: "anywhere", pt: 0.5, pb: 0.6 }}>
                  {name}
                </Typography>
              </Stack>
            )}
            <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1.25}>
              {privateConversation && <Box sx={{ width: "30px", height: "30px", flexShrink: 0 }}></Box>}
              <Box
                sx={{
                  display: "inline-block",
                  wordWrap: "break-word",
                  whiteSpace: "pre-wrap",
                  float: "left",
                  bgcolor: "#DBEFFF",
                  color: "common.black",
                  borderRadius: "6px",
                  p: "9px 12px 9px 12px",
                }}
              >
                {image && <ImageViewer file={image} />}
                {file && <AttachmentFileDownload attachment={file} />}

                <Stack direction="row" alignItems="center" justifyContent="start">
                  <Typography variant="chat" sx={{ overflowWrap: "anywhere" }}>
                    {message}
                  </Typography>
                  <Typography variant="date" sx={{ visibility: "hidden", pl: 1 }}>
                    {date && moment(date).format("LT")}
                  </Typography>
                </Stack>
                <Box sx={{ display: "inline-block", float: "right", lineHeight: "10px", marginBottom: "-8px", marginRight: "-5px", marginTop: "-10px" }}>
                  <Typography variant="date" component="span" align="right" sx={{ color: "common.black" }}>
                    {date && moment(date).format("LT")}
                  </Typography>
                </Box>
              </Box>
              <ChatMessageAction messageObj={msgObj} date={date} direction="LEFT" />
            </Stack>
          </Grid>

          <Grid item xs={2} md={3} xl={4} />
        </Grid>
      </Stack>
    </Grid>
  );
};

export default MessageL;

export const DeleteMessageL = ({ date, name, user, isSameUser, userId, privateConversation = false }) => {
  return (
    <Grid item xs={12}>
      <Stack direction="row" alignItems="flex-start">
        <Grid
          container
          justifyContent="flex-start"
          sx={{
            ...(isSameUser ? { mt: "3px" } : { mt: "5px" }),
          }}
        >
          <Grid item xs={10} md={9} xl={8}>
            {!isSameUser && (
              <Stack direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={1.25}>
                {/* <ChatUserAvatar user={user} /> */}
                <UserAvatar3 userId={userId} width={30} height={30} />
                <Typography variant="subtitle1" color="textPrimary" sx={{ overflowWrap: "anywhere", pt: 0.5, pb: 0.6 }}>
                  {name}
                </Typography>
              </Stack>
            )}
            <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1.25}>
              {privateConversation && <Box sx={{ width: "30px", height: "30px", flexShrink: 0 }}></Box>}
              <Box
                sx={{
                  display: "inline-block",
                  wordWrap: "break-word",
                  whiteSpace: "pre-wrap",
                  float: "left",
                  bgcolor: "#9090902b",
                  color: "#909090",
                  borderRadius: "6px",
                  p: "9px 12px 9px 12px",
                }}
              >
                <Stack direction="row" alignItems="center" justifyContent="start">
                  <Typography variant="chat" sx={{ overflowWrap: "anywhere" }}>
                    This message was deleted
                  </Typography>
                  <Typography variant="date" sx={{ visibility: "hidden", pl: 1 }}>
                    {date && moment(date).format("LT")}
                  </Typography>
                </Stack>
                <Box sx={{ display: "inline-block", float: "right", lineHeight: "10px", marginBottom: "-8px", marginRight: "-5px", marginTop: "-10px" }}>
                  <Typography variant="date" component="span" align="right">
                    {date && moment(date).format("LT")}
                  </Typography>
                </Box>
              </Box>
            </Stack>
          </Grid>

          <Grid item xs={2} md={3} xl={4} />
        </Grid>
      </Stack>
    </Grid>
  );
};

export const ReplyMessageL = ({ message, date, name, reply, replyUserName, replyMessage, msgObj, user, isSameUser, userId, privateConversation = false }) => {
  return (
    <Grid item xs={12}>
      <Stack direction="row" alignItems="flex-start">
        <Grid
          container
          justifyContent="flex-start"
          sx={{
            ...(isSameUser ? { mt: "3px" } : { mt: "5px" }),
          }}
        >
          <Grid item xs={10} md={9} xl={8}>
            {!isSameUser && (
              <Stack direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={1.25}>
                {/* <ChatUserAvatar user={user} /> */}
                <UserAvatar3 userId={userId} width={30} height={30} />
                <Typography variant="subtitle1" color="textPrimary" sx={{ overflowWrap: "anywhere", pt: 0.5, pb: 0.6 }}>
                  {name}
                </Typography>
              </Stack>
            )}
            <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1.25}>
              {privateConversation && <Box sx={{ width: "30px", height: "30px", flexShrink: 0 }}></Box>}
              <Box
                sx={{
                  display: "inline-block",
                  wordWrap: "break-word",
                  whiteSpace: "pre-wrap",
                  float: "left",
                  bgcolor: "#DBEFFF",
                  color: "common.black",
                  borderRadius: "6px",
                  p: "9px 12px 9px 12px",
                }}
              >
                <Reply replyObj={reply} replyUserName={replyUserName} replyMessage={replyMessage} />
                <Stack direction="row" alignItems="center" justifyContent="start">
                  <Typography variant="chat" sx={{ overflowWrap: "anywhere" }}>
                    {message}
                  </Typography>
                  <Typography variant="date" sx={{ visibility: "hidden", pl: 1 }}>
                    {date && moment(date).format("LT")}
                  </Typography>
                </Stack>
                <Box sx={{ display: "inline-block", float: "right", lineHeight: "10px", marginBottom: "-8px", marginRight: "-5px", marginTop: "-10px" }}>
                  <Typography variant="date" component="span" align="right" sx={{ color: "common.black" }}>
                    {date && moment(date).format("LT")}
                  </Typography>
                </Box>
              </Box>
              <ChatMessageAction messageObj={msgObj} date={date} direction="LEFT" />
            </Stack>
          </Grid>

          <Grid item xs={2} md={3} xl={4} />
        </Grid>
      </Stack>
    </Grid>
  );
};
